/**
 * Calculates the total monthly price by combining the base price and per-employee price
 *
 * @param props - Object containing calculation parameters
 * @param props.base - Base monthly price (fixed cost)
 * @param props.price - Price per employee per month
 * @param props.nbEmployee - Number of employees
 *
 * @returns The total monthly price: base + (price * nbEmployee)
 *
 * @example
 * ```ts
 * const total = calculateTotal({
 *   base: 100,    // Base price: €100
 *   price: 50,    // €50 per employee
 *   nbEmployee: 5 // 5 employees
 * });
 * // Returns: 350 (100 + 50 * 5)
 * ```
 */
type calculateTotalProps = {
  base: number;
  price: number;
  nbEmployee: number;
};

export default function calculateTotal({
  base,
  price,
  nbEmployee,
}: calculateTotalProps): number {
  return base + price * nbEmployee;
}
